import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * Catches render / lifecycle throws so a single malformed response (mapped in a
 * screen's render) can't unmount the whole app to a blank page. The global
 * window.onerror reporter in main.tsx still records the throw; this just keeps a
 * recoverable UI on screen. Class component because that's the only way to catch
 * render errors in React.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return (
      <div className="card" role="alert" style={{ maxWidth: 520, margin: '48px auto' }}>
        <h2 className="card-title">خطای غیرمنتظره</h2>
        <p className="muted" style={{ marginTop: 0 }}>
          این بخش دچار خطا شد و ادامه نیافت. صفحه را دوباره بارگذاری کنید؛ اگر تکرار شد، به پشتیبانی
          اطلاع دهید.
        </p>
        <div className="row" style={{ marginTop: 12 }}>
          <button type="button" className="btn btn-primary" onClick={() => location.reload()}>
            بارگذاری دوباره
          </button>
        </div>
      </div>
    );
  }
}
